<div id="div2" style="display:block">
    <br><br>
    <p align="center" style="font-size:x-large;">
        <b> <span id="lblMsg" style="font-weight:bold;">Please contact your agent if you’d like to have a copy of the Scope of Appointment.

</span> </b>
    </p>
    <br>
